// extracted by mini-css-extract-plugin
export default {"page-data-menu":"PageDataMenu_page-data-menu__5YlPp","scale-section-down":"PageDataMenu_scale-section-down__-01tR"};